import { atomWithReset } from "jotai/utils";

// null -> not in measurement mode
// true -> in measurement mode and reference measurement mode
// false -> in measurement mode but NOT reference measurement mode
export const isReferenceMeasurementModeActiveAtom = atomWithReset<
  boolean | null
>(null);
